import CollapsibleSection from "components/Section";
import React from "react";
import TextValue from "components/TitleValue";
import { useTranslation } from "react-i18next";
import { TWaterMeter, WaterMeterAlarmsType } from "types/dto";

import { Chip } from "@mui/material";
import { EnumFlag2Array } from "utils/enumTools";
import { getHourDiff, getJalaliDate } from "utils/dateTimeTools";

type TProps = {
  data?: TWaterMeter;
  isLoading?: boolean;
};
export const MeterStatus = (props: TProps) => {
  const { data, isLoading } = props;

  const { t } = useTranslation();

  const getAlarmsValue = (alarms?: number) => {
    const values = EnumFlag2Array(WaterMeterAlarmsType, alarms || 0);
    const res = [];
    if (values && values.length > 0) {
      for (let i = 0; i < values.length; i++) {
        res.push(t("enum-" + WaterMeterAlarmsType[values[i]]));
      }
      return res.join(", ");
    } else {
      return t("enum-None");
    }
  };

  return (
    <CollapsibleSection
      title={t("meterStatus")}
      collapsible={true}
      isLoading={isLoading}
      skeleton="text"
      skeletonRows={3}
    >
      <div className={"flex w-full flex-col gap-y-6 items-end"}>
        <Chip
          size={"small"}
          label={
            getHourDiff(
              data?.lastSyncDT
                ? new Date(data?.lastSyncDT)
                : new Date("2020-01-01"),
              new Date()
            ) > 72
              ? t("inactive")
              : t("active")
          }
          color={
            getHourDiff(
              data?.lastSyncDT
                ? new Date(data?.lastSyncDT)
                : new Date("2020-01-01"),
              new Date()
            ) > 72
              ? "default"
              : "success"
          }
          className={"text-md font-bold m-0 p-0 w-16 mb-9"}
        />
        <TextValue
          title={t("lastSyncDT")}
          // Sync time matters as much as the date when judging staleness.
          value={
            data?.lastSyncDT
              ? getJalaliDate({
                  date: data.lastSyncDT,
                })
              : "—"
          }
        />
        <TextValue
          title={t("lastReading")}
          value={
            data?.lastReading != null ? `${data.lastReading} ${t("mr3")}` : "—"
          }
        />
        <TextValue
          title={t("reportedLastAlarm")}
          value={getAlarmsValue(data?.readingData?.latestAlarm)}
        />
        <TextValue
          title={t("batteryStatus")}
          value={
            data?.batteryPercentage != null ? `${data.batteryPercentage}%` : "—"
          }
        />
      </div>
    </CollapsibleSection>
  );
};
